import { UnknownFund } from "../../types";
import Isin from "./Cells/Isin";
import ManageCompanyCell from "./Cells/ManageCompanyCell/ManageCompanyCell";
import Name from "./Cells/Name";
import Save from "./Cells/Save";
import TaxExempt from "./Cells/TaxExempt";

type Col = {
	id: string;
	Cell: (right: UnknownFund) => JSX.Element | null;
	label: string;
	align?: "center" | "left";
};

const cols: Col[] = [
	{
		id: "name",
		Cell: Name,
		align: "left",
		label: "Nombre"
	},
	{
		id: "isin",
		Cell: Isin,
		label: "ISIN",
		align: "center"
	},
	{
		id: "tax_exempt",
		Cell: TaxExempt,
		label: "Exento de impuestos",
		align: "center"
	},
	{
		id: "manage_company",
		Cell: ManageCompanyCell,
		label: "Gestora",
		align: "center"
	},
	{
		id: "save",
		Cell: Save,
		label: "",
		align: "center"
	}
];

export default cols;
